export const downloadBlob = (blob: Blob, fileName: string) => {
    const href = URL.createObjectURL(blob);

    const anchorElement = document.createElement('a');
    anchorElement.href = href;
    anchorElement.download = fileName;

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
};
